export const COLOR_EMG_QUERY_PARAM = 'color_emg';
